import { onlyNumbers } from '@/utils/regex-utils';

export default {
  centrosCustos(state) {
    return state.centrosCustos;
  },
  solicitantes(state) {
    return state.solicitantes;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  localEntrega(state) {
    return state.localEntrega;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  grupo(state) {
    return state.grupo;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  dataEntregaInicial(state) {
    return state.dataEntregaInicial;
  },
  dataEntregaFinal(state) {
    return state.dataEntregaFinal;
  },
  urgencia(state) {
    return state.urgencia;
  },
  showEspecificacao(state) {
    return state.showEspecificacao;
  },
  showObservacaoExterna(state) {
    return state.showObservacaoExterna;
  },
  showObservacaoInterna(state) {
    return state.showObservacaoInterna;
  },
  compradores(state) {
    return state.compradores;
  },
  listOptions(state) {
    return state.listOptions;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.localEntrega,
      state.solicitantes && state.solicitantes.length,
      state.produto && state.produto.length,
      state.centrosCustos && state.centrosCustos.length,
      state.projeto && state.projeto.length,
      state.grupo && state.grupo.length,
      state.dataFinal,
      state.dataInicial,
      state.dataEntregaInicial,
      state.dataEntregaFinal,
      state.urgencia && state.urgencia.length,
      state.compradores && state.compradores.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = ['(situacao = "RECEBIDA")'];
    if (state.searchText) {
      const idFilter = onlyNumbers(state.searchText.trim()) ? ` or requisicao.id = ${onlyNumbers(state.searchText.trim())}` : '';
      const searchText = state.searchText.trim().toLowerCase();
      filters.push(`(produto.nome like '%${searchText}%' or especificacaoProduto like '%${searchText}%' or identificador like '%${searchText}%' or responsavel.name like '%${searchText}%' or requisicao.codigoInterno like '%${searchText}%'${idFilter})`);
    }
    if (state.centrosCustos && state.centrosCustos.length) {
      const centroCustosFilter = state.centrosCustos.map(centroCusto => `(centroCusto = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.solicitantes && state.solicitantes.length) {
      const solicitantesFilter = state.solicitantes.map(solicitante => `responsavel = ${solicitante.id}`);
      filters.push(`(${solicitantesFilter.join(' or ')})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.localEntrega && state.localEntrega.id) {
      filters.push(`(localEntrega.id = ${state.localEntrega.id})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(grupo => `(produto.categoria.id = ${grupo.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    if (state.dataInicial) {
      filters.push(`requisicao.dataRegistro >= ${state.dataInicial}`);
    }
    if (state.dataFinal) {
      filters.push(`requisicao.dataRegistro <= ${state.dataFinal}`);
    }
    if (state.dataEntregaInicial) {
      filters.push(`dataPrevisaoEntrega >= ${state.dataEntregaInicial}`);
    }
    if (state.dataEntregaFinal) {
      filters.push(`dataPrevisaoEntrega <= ${state.dataEntregaFinal}`);
    }
    if (state.urgencia && state.urgencia.length) {
      const urgenciaFilter = state.urgencia.map(urgencia => `(requisicao.urgencia = '${urgencia}')`);
      filters.push(`(${urgenciaFilter.join(' or ')})`);
    }

    if (state.compradores && state.compradores.length) {
      const compradoresFilter = state.compradores.map(comprador => `requisicao.compradorResponsavel.id = ${comprador.id}`);
      filters.push(`(${compradoresFilter.join(' or ')})`);
    }

    return filters.join(' and ');
  },
};
